import { jsx as _jsx } from "react/jsx-runtime";
const ProgressBar = ({ progressDone }) => (_jsx("div", Object.assign({ className: 'progress progress-sm' }, { children: _jsx("div", { className: 'progress-bar', role: 'progressbar', style: { width: progressDone }, "aria-valuenow": 45, "aria-valuemin": 0, "aria-valuemax": 100 }) })));
export default ProgressBar;
